import * as React from "react";
import type { SVGProps } from "react";
const SvgThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M12.083 7.915V5.438a2.92 2.92 0 0 0-1.971-2.76l-.325-.11a1.25 1.25 0 0 0-1.59.785l-1.53 4.563h-2.97c-.66 0-1.197.537-1.197 1.198v7.188c0 .661.536 1.198 1.198 1.198h11.04c1.1 0 2.058-.749 2.325-1.815l1.198-4.792a2.395 2.395 0 0 0-2.325-2.977h-3.853M6.667 17.5V7.915"
    />
  </svg>
);
export default SvgThumbsUp;
